<template>
    <div class="phoneWraper">
        <div class="form form-2">
            <div class="group group-1">
                <svg xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink"
                     width="19px"
                     height="22px"
                     class="svg">
                    <path fill-rule="evenodd"
                          fill="rgb(187, 187, 187)"
                          d="M9.493,11.001 C12.498,11.001 14.938,8.538 14.938,5.500 C14.938,2.462 12.498,-0.000 9.493,-0.000 C6.486,-0.000 4.048,2.462 4.048,5.500 C4.048,8.538 6.484,11.001 9.493,11.001 ZM16.994,14.433 C15.750,12.997 15.329,12.503 13.052,12.371 L5.942,12.371 C3.662,12.506 3.244,12.997 2.003,14.433 C0.681,15.914 -0.372,17.796 0.126,20.124 C0.681,21.650 2.174,22.000 3.591,22.000 L15.407,22.000 C16.823,22.000 18.319,21.647 18.874,20.124 C19.367,17.796 18.316,15.916 16.994,14.433 Z" />
                </svg>
                <input type="text"
                       class="userName"
                       v-model="formPhone.passport"
                       placeholder="请输入手机号"
                       maxlength="11"
                       spellcheck="false"
                       @focus="fnInputFocus" />
            </div>
            <div class="group group-2">
                <svg xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink"
                     width="19px"
                     height="23px"
                     class="svg">
                    <path fill-rule="evenodd"
                          fill="rgb(187, 187, 187)"
                          d="M18.952,4.877 C18.932,4.172 18.388,3.506 17.746,3.385 C17.746,3.385 15.255,2.962 13.857,2.428 C12.112,1.760 10.385,0.293 10.385,0.293 C9.846,-0.120 9.020,-0.094 8.520,0.353 C8.520,0.353 7.298,1.678 5.017,2.452 C2.909,3.362 1.225,3.455 1.225,3.455 C0.589,3.544 0.042,4.175 0.029,4.880 C0.029,4.880 -0.056,8.504 0.052,11.685 C0.093,17.375 6.361,23.000 9.529,23.000 C12.647,23.000 18.036,19.081 18.883,11.767 C19.093,7.425 18.952,4.877 18.952,4.877 ZM14.089,9.869 L8.699,15.731 C8.469,15.981 8.080,16.010 7.816,15.784 L5.001,13.381 C4.484,12.939 4.430,12.171 4.888,11.656 C5.342,11.146 6.122,11.078 6.650,11.522 L7.956,12.621 L12.446,8.075 C12.914,7.601 13.658,7.615 14.114,8.083 C14.108,8.076 14.106,8.066 14.099,8.058 L14.137,8.099 C14.130,8.092 14.121,8.090 14.114,8.083 C14.553,8.579 14.547,9.370 14.089,9.869 Z" />
                </svg>
                <input type="text"
                       class="verifyCode"
                       v-model="formPhone.verifyCode"
                       placeholder="请输入验证码"
                       maxlength="6"
                       @focus="fnInputFocus"
                       @keyup.enter="fnDoSubmit" />
                <a href="javascript:;"
                   class="btnNml btnGetVerifyCode"
                   :class="{btnGray: btnDisable}"
                   @click="fnVerify"
                   v-text="btnVerifyCode"></a>
            </div>
            <div class="flex group group-3">
                <div class="errMsg"
                     v-text="formPhone.errMsg"></div>
                <div class="forgetPwd">
                    <a href="javascript:;"
                       @click="fnSwitchLoger('forget')">忘记密码？</a>
                </div>
            </div>
            <div class="group group-4">
                <a href="javascript:;"
                   class="btnNml btnSubmit"
                   @click="fnDoSubmit"
                   v-text="btnSubmitTxt">开始游戏</a>
            </div>
            <div class="group group-5">
                还没有账号？
                <a href="javascript:;"
                   class="colorfd9d2b"
                   @click="fnSwitchLoger('register')">立即注册</a>
            </div>
            <div class="group group-6">
                <div class="otherLogin"></div>
                <div class="otherLoginWraper">
                    <!--pc登录-->
                    <a href="javascript:;"
                       class="item item-2"
                       @click="fnSwitchLoger('normal')">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="26px"
                             height="24px"
                             style="top:12px;left:0px">
                            <path fill-rule="evenodd"
                                  fill="rgb(255, 255, 255)"
                                  d="M23.000,18.000 L3.000,18.000 L-0.000,18.000 L-0.000,15.000 L-0.000,3.000 L-0.000,-0.000 L3.000,-0.000 L23.000,-0.000 L26.000,-0.000 L26.000,3.000 L26.000,15.000 L26.000,18.000 L23.000,18.000 ZM23.000,3.000 L3.000,3.000 L3.000,15.000 L23.000,15.000 L23.000,3.000 ZM21.000,24.000 L5.000,24.000 L5.000,21.000 L21.000,21.000 L21.000,24.000 Z" />
                        </svg>
                    </a>
                    <!--QQ登录-->
                    <a href="javascript:;"
                       class="item item-4"
                       @click="fnSwitchLoger('qq')">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="25px"
                             height="28px"
                             style="top:8px;left:0px">
                            <path fill-rule="evenodd"
                                  fill="rgb(255, 255, 255)"
                                  d="M24.278,16.489 C23.768,15.177 21.800,12.194 21.777,10.695 L21.765,10.695 C21.769,10.616 21.777,10.536 21.777,10.457 C21.777,5.011 17.757,0.599 12.799,0.599 C7.839,0.599 3.821,5.011 3.821,10.457 C3.821,10.536 3.829,10.616 3.831,10.695 L3.821,10.695 C3.798,12.194 1.831,15.177 1.320,16.489 C0.808,17.807 0.680,19.134 0.916,20.188 C1.153,21.241 1.347,21.892 1.572,22.097 C1.795,22.307 2.008,22.527 2.685,22.063 C3.228,21.627 3.821,20.739 3.821,20.739 C3.821,20.739 4.312,22.117 5.407,23.168 C4.548,23.562 3.305,24.439 3.216,25.012 C3.131,25.581 4.519,27.748 7.781,27.797 C11.042,27.842 12.126,26.473 12.233,26.367 C12.537,26.055 12.799,25.865 12.799,25.865 C12.799,25.865 13.062,26.055 13.365,26.367 C13.472,26.473 14.556,27.842 17.817,27.797 C21.078,27.748 22.467,25.581 22.380,25.012 C22.292,24.439 21.048,23.562 20.190,23.168 C21.284,22.117 21.777,20.739 21.777,20.739 C21.777,20.739 22.370,21.627 22.913,22.063 C23.588,22.527 23.801,22.307 24.026,22.097 C24.251,21.892 24.443,21.241 24.681,20.188 C24.918,19.134 24.788,17.807 24.278,16.489 Z" />
                        </svg>
                    </a>
                    <!--微信登录-->
                    <a href="javascript:;"
                       class="item item-5"
                       @click="fnSwitchLoger('weixin')">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="28px"
                             height="24px"
                             style="top:12px;left:1px">
                            <path fill-rule="evenodd"
                                  fill="rgb(255, 255, 255)"
                                  d="M24.027,20.767 L24.752,23.198 L22.111,21.737 C21.148,21.980 20.181,22.225 19.222,22.225 C14.642,22.225 11.034,19.059 11.034,15.161 C11.034,11.271 14.642,8.099 19.222,8.099 C23.548,8.099 27.400,11.271 27.400,15.161 C27.400,17.357 25.960,19.300 24.027,20.767 ZM16.568,11.997 C16.088,11.997 15.605,12.486 15.605,12.969 C15.605,13.462 16.088,13.944 16.568,13.944 C17.296,13.944 17.773,13.462 17.773,12.969 C17.773,12.486 17.296,11.997 16.568,11.997 ZM21.863,11.997 C21.387,11.997 20.907,12.486 20.907,12.969 C20.907,13.462 21.387,13.944 21.863,13.944 C22.585,13.944 23.068,13.462 23.068,12.969 C23.068,12.486 22.585,11.997 21.863,11.997 ZM10.428,15.278 C10.428,15.987 10.537,16.668 10.726,17.318 C10.428,17.342 10.129,17.357 9.827,17.357 C8.625,17.357 7.659,17.108 6.455,16.868 L3.089,18.574 L4.052,15.646 C1.642,13.944 0.200,11.749 0.200,9.076 C0.200,4.445 4.535,0.798 9.827,0.798 C14.560,0.798 18.707,3.712 19.540,7.633 C19.234,7.599 18.925,7.575 18.613,7.575 C14.040,7.575 10.428,11.026 10.428,15.278 ZM6.699,4.936 C5.978,4.936 5.250,5.419 5.250,6.151 C5.250,6.881 5.978,7.370 6.699,7.370 C7.421,7.370 7.901,6.881 7.901,6.151 C7.901,5.419 7.421,4.936 6.699,4.936 ZM13.437,4.936 C12.715,4.936 11.991,5.419 11.991,6.151 C11.991,6.881 12.715,7.370 13.437,7.370 C14.162,7.370 14.642,6.881 14.642,6.151 C14.642,5.419 14.162,4.936 13.437,4.936 Z" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'phone',
    data () {
        return {
            formPhone: {
                passport: '',
                verifyCode: '',
                errMsg: ''
            },
            captchaObj: null,
            btnSubmitTxt: '开始游戏',
            btnDisable: false,
            btnVerifyCode: '获取验证码',
            btnVerifyCodeNum: 60,
            btnVerifyCodeTimer: null,
        }
    },
    mounted () {
        let t = this
        t.captchaObj && t.captchaObj.reset()
        t.fnGeeInit(function (geeData) {
            t.fnGetVerifyCode(geeData)
        })
    },
    methods: {
        // 获取验证码
        fnGetVerifyCode (geeData) {
            let t = this
            if (!t.formPhone.passport) {
                t.formPhone.errMsg = '手机号不能为空'
                return
            }
            if (t.btnDisable) return
            t.btnDisable = true
            geeData = geeData || {}
            geeData.phone = t.formPhone.passport
            geeData.source_page = ELSDK.SourcePage.box || 'yilewan_pcbox'
            this.fnSendPhoneCode(geeData)
        },
        fnVerify () {
            let t = this
            if (!t.formPhone.passport) {
                t.formPhone.errMsg = '手机号不能为空'
                return
            }
            this.captchaObj.verify()
        },
        // 发送验证码
        fnSendPhoneCode (geeData, type) {
            var t = this
            // eslint-disable-next-line
            ELSDK.SDKAPI('phoneCode', geeData, (res) => {
                if (res.status === 'error') {
                    t.btnDisable = false
                    if (type) {
                        t.formForget.errMsg = res.msg
                    } else {
                        t.formPhone.errMsg = res.msg
                    }
                    return
                }
                t.btnVerifyCodeTimer = setInterval(() => {
                    t.btnVerifyCodeNum--
                    if (t.btnVerifyCodeNum < 1) {
                        t.btnVerifyCodeNum = 0
                        t.btnVerifyCodeNum = 60
                        t.btnDisable = false
                        t.btnVerifyCode = '获取验证码'
                        clearInterval(t.btnVerifyCodeTimer)
                        return
                    }
                    t.btnVerifyCode = t.btnVerifyCodeNum + 's后重新获取'
                }, 1000)
            })
        },
        // 表单提交
        fnDoSubmit () {
            var t = this
            if (!t.formPhone.passport) {
                t.formPhone.errMsg = '手机号不能为空'
                return
            }
            if (!t.formPhone.verifyCode) {
                t.formPhone.errMsg = '验证码不能为空'
                return
            }
            // eslint-disable-next-line
            ELSDK.SDKAPI(
                'phone',
                {
                    phone: t.formPhone.passport,
                    code: t.formPhone.verifyCode,
                    source_page: 'yilewan_pcbox',
                    game_code: t.$cookies.get('jsGameCode') || '',
                    attr: t.$cookies.get('jsGameCode') ? 'game' : '',
                    attr_value: t.$cookies.get('jsGameCode') ? t.$cookies.get('jsGameCode') : ''
                },
                function (res) {
                    if (res.status === 'error') {
                        t.formPhone.errMsg = res.msg
                        return
                    }
                    t.$emit('fnGetYilewanToken', res.data.is_first)
                }
            )
        },
        // 极验初始化
        fnGeeInit (fn) {
            var t = this
            // eslint-disable-next-line
            ELSDK.SDKAPI('geeInit', {}, (captchaObj) => {
                // debugger
                t.captchaObj = captchaObj
                t.captchaObj.onSuccess(function () {
                    var result = t.captchaObj.getValidate()
                    if (!result) {
                    } else {
                        var geeData = {
                            gee_client_type: 'web',
                            gee_challenge: result.geetest_challenge,
                            gee_validate: result.geetest_validate,
                            gee_seccode: result.geetest_seccode
                        }
                        fn && fn(geeData)
                    }
                })
            })
        },
        // 获取焦点
        fnInputFocus () {
            this.formPhone.errMsg = ''
        },
        fnSwitchLoger (type) {
            this.$emit('fnBtnClick', type)
        },
    },
    destroyed () {
        clearInterval(this.btnVerifyCodeTimer)
    }
}
</script>
